<div class="form-layout-compact">
    <ng-container *ngIf="lmWebAppComponent then COMPONENT"></ng-container>
    <ng-container *ngIf="lmWebAppComponentItem then ITEM"></ng-container>
</div>

<!-- COMPONENT -->
<ng-template #COMPONENT>
    <div class="displayOnInfo font-size-sm">{{'DisplayTargets' | translate}}</div>
    <soho-listview
       selectable='true'
       disableItemDeactivation="'true'">
        <li soho-listview-item  *ngFor="let targetInfo of lmWebAppComponent.target; index as i" class="lm-flex-column-nowrap">
            <div class="lm-flex-row-two-table-container">
                <div attr.data-automation-id="lm-menu-security-info-displayType-{{i}}" class="displayOnInfo font-size-sm">{{targetInfo.displayType}}</div>
                <div attr.data-automation-id="lm-menu-security-info-displayVersion-{{i}}" class="displayOnInfo font-size-sm">{{targetInfo.displayVersion}}</div>
            </div>
            <div *ngIf="targetInfo.showCondition" attr.data-automation-id="lm-menu-security-info-showCondition-{{i}}" class="displayOnInfo font-size-xs">{{'ValidWhen' | translate}} {{targetInfo.showCondition}}</div>
        </li>
    </soho-listview>
</ng-template>

<!-- ITEM -->
<ng-template #ITEM>
    <div class="row field">
        <label soho-label for="lm-menu-security-info-property-id">{{'PropertyId' | translate}}</label>
        <input soho-input data-automation-id="lm-menu-security-info-property-id"
               name="lm-menu-security-info-property-id"
               id="lm-menu-security-info-property-id"
               [readOnly]="true"
               [(ngModel)]="lmWebAppComponentItem.propertyId">
    </div>
    <div class="row field">
        <label soho-label for="lm-menu-security-info-target-link">{{ 'MenuLink' | translate }}</label>
        <input soho-input data-automation-id="lm-menu-security-info-target-link"
            name="lm-menu-security-info-target-link"
            id="lm-menu-security-info-target-link"
            [readOnly]="true"
            [(ngModel)]="lmWebAppComponentItem.target.link">
    </div>
    <ng-container *ngIf="lmWebAppComponentItem.searchTerms?.length > 0">
        <label soho-label data-automation-id="lm-menu-security-info-search-term-label">{{'SearchTerms' | translate}}</label>
        <li *ngFor="let term of lmWebAppComponentItem.searchTerms; index as i" class="font-size-sm" attr.data-automation-id="lm-menu-security-info-search-term-{{i}}">{{term}}</li>
    </ng-container>
</ng-template>